import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import {
    ChangePasswordRequest,
    EditUserProfileRequest,
    UserProfile
} from "../models/user-profile-portal.model";

@Injectable({ providedIn: 'root' })
export class UserProfilePortalEndpoint {
    private readonly http = inject(HttpClient);

    private readonly endpoints = {
        selectedCreditUnion: (creditUnionId: string) => `user-profile/selected-credit-union/${creditUnionId}`,
        onboardingComplete: 'user-profile/onboarding/complete',
        userProfile: 'user-profile',
        changePassword: 'user-profile/change-password'
    };

    setSelectedCreditUnion(creditUnionId: string): Observable<void> {
        return this.http.post<void>(this.endpoints.selectedCreditUnion(creditUnionId), null);
    }

    completeOnboarding(): Observable<void> {
        return this.http.post<void>(this.endpoints.onboardingComplete, null);
    }

    getUserProfile(): Observable<UserProfile> {
        return this.http.get<UserProfile>(this.endpoints.userProfile);
    }

    editUserProfile(body: EditUserProfileRequest): Observable<void> {
        return this.http.patch<void>(this.endpoints.userProfile, body);
    }

    changePassword(body: ChangePasswordRequest): Observable<void> {
        return this.http.patch<void>(this.endpoints.changePassword, body);
    }
}
